import React from 'react';
import ReactTable from 'react-table';
import 'react-table/react-table.css';

const customFilter = (filter, row) => {
  const id = filter.pivotId || filter.id;
  if (row[id] !== null && typeof row[id] === 'string') {
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  }
};

const List = ({ ...props }) => <ReactTable defaultFilterMethod={customFilter} {...props} />;

export default List;



// WEBPACK FOOTER //
// ./src/List.js